export const EstadoGlosa = [
    {
        estado: "RECHAZADO_SAT",
        nombre: "PENDIENTE"
    }, {
        estado: "ANULADO_SAT",
        nombre: "ANULADO"
    }, {
        estado: "GESTIONADO_SAT",
        nombre: "GESTIONAR"
    }, {
        estado: "EXITO_ENVIO_SAT",
        nombre: "SOLUCIONADO"
    }, {
        estado: "ENVIO_FUTURO",
        nombre: "NOTIFICACION_FUTURA"
    }, {
        estado: "GESTION_INVALIDA",
        nombre: "INVALIDO"
    }, {
        estado: "EN_PROCESO_SAT",
        nombre: "PROCESANDO"
    }];


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/procesar_masivo_glosas/modelo/EstadoGlosa.ts